/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'FACILITY_HAS_PERFORMED_AN_ASBESTOS_EXPOSURE_ASSESSMENT',
              'FACILITY_HAS_TAKEN_THE_PROPER_STEPS_TO_ENSURE_THAT_WORKERS_ARE_',
              'MATERIALS_CONTAINING_ASBESTOS_ASBESTOS_EXPOSURE_AREAS_ARE_LABEL',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_safety_measures_in_place_regarding_asbestos_s: valueSchema,
  },
}
